import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

function LinearProgressWithLabel({ value=0, height,bgcolor,islarge }) {
  return (
    <Box>
      {/* Title & Progress Count */}
      {/* <Box sx={{ display: 'flex', justifyContent: islarge?"flex-end":"space-between" }}>
        {!islarge && (
          <Typography variant='h5'>Lesson Progress</Typography>
        )}
        {
          islarge?<Typography variant='h5'>{value} %</Typography>:<Typography variant='h5'>3/20</Typography>
        }
      </Box> */}

      {/* Progress Bar */}
      <Box>
        <LinearProgress 
          variant="determinate" 
          value={value} 
          sx={{ 
               borderRadius:"15px",
            height: height || 10, // Default height to 10px if not provided
            backgroundColor: '#F2F2F2',
            '& .MuiLinearProgress-bar': { backgroundColor:bgcolor || 'blue.light' }
          }} 
        />
      </Box>
    </Box>
  );
}

// Prop Types
LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
  height: PropTypes.number, // Height prop added
};

// Main Progress Bar Component
const ProgressBar = ({ height = 10 , value=0,bgcolor,islarge}) => {
  return (
    <Box >
      <LinearProgressWithLabel value={value} height={height} bgcolor={bgcolor} islarge={islarge}/>
    </Box>
  );
}

// Export Component
export default ProgressBar;
